export default __webpack_public_path__ + "media/sulamerica_308px_116px-06.png";